import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import 'virtual:windi.css'
import App from './App'
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GlobalDataProvider } from "./context/globalContext";
import { Toaster } from 'react-hot-toast'

ReactDOM.render(
  <React.StrictMode>
    <GlobalDataProvider>
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
    <Toaster />
    <App />
    </GoogleOAuthProvider>
    </GlobalDataProvider>
  </React.StrictMode>,
  document.getElementById('root')
)
